import { motion } from 'motion/react';
import { BackgroundAsset, FRAME_TRANSITION_DURATION } from '@/app/components/questionnaireV2/components/survey-item/components/interstitial/interstitial-shared';
import { RecalculatingCancerRisk } from './recalculating-cancer-risk';

export function RecalculationInterstitial() {
  const config = {
    backgroundAsset: '/videos/twilight.mp4',
  };


  return (
    <div className="interstitial-outro-container">
      <div className="interstitial-outro-background" />

      <BackgroundAsset backgroundAsset={config.backgroundAsset} classNamePrefix="interstitial-outro" />

      <div
        className="interstitial-outro-overlay"
        style={{
          opacity: 0.6,
          backgroundColor: 'rgba(0, 0, 0, 0.65)',
          backdropFilter: 'blur(35px)',
          WebkitBackdropFilter: 'blur(35px)', // Safari support
        }}
      />

      <div className="relative z-10 flex h-full w-full flex-col items-center justify-start">
        <motion.div
          className="interstitial-outro-content h-full w-full"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: FRAME_TRANSITION_DURATION,
            ease: 'easeOut',
          }}
          style={{ willChange: 'transform, opacity' }}
        >
          <RecalculatingCancerRisk />
        </motion.div>
      </div>
    </div>
  );
}
